import { TemplateTypes } from '../constants/templateConstants';

const initialState = {
    tool: null,
    props: {},
    selectedId: null,
    content: [],
    loadedContent: [],
    pages: 1,
    minPages: 1,
};

const setPages = (state, pages) => {
    if (state.content.length) {
        return {
            page1: [...state.content]
        };
    }

    const currentNumPages = Object.keys(state.content).length;
    let result = {...state.content};

    if (currentNumPages < pages) {
        for (let i=1; i<=pages; i++) {
            if (result['page'+i] === undefined) {
                result['page'+i] = [];
            }
        }
    } else {
        for (let i=currentNumPages; i>pages; i--) {
            if (result['page'+i].length) {
                break;
            } 
            delete result['page'+i];
        }
    }

    return result;
}

export const templateReducer = (state = initialState, action) => {
    switch (action.type) {
        case TemplateTypes.SET_ADDFIELD:
            return {
                ...state,
                tool: action.tool,
            };

        case TemplateTypes.SET_FIELD_PROP:
            return {
                ...state,
                props: {...state.props, [action.key]: action.value},
            };

        case TemplateTypes.CLEAN_FIELD_PROP:
            return {
                ...state,
                props: {},
            };

        case TemplateTypes.SET_SELECTED:
            return {
                ...state,
                selectedId: action.id,
                props: {...state.props, ...action.props},
            };

        case TemplateTypes.SET_CONTENT:
            const content = action.content.length ? setPages({...state, content: action.content}, 1) : {...action.content};
            //console.log('content', content);
            return {
                ...state,
                content
            };

        case TemplateTypes.LOAD_CONTENT:
            return {
                ...state,
                loadedContent: action.content.length ? [...action.content] : {...action.content}
            };

        case TemplateTypes.SET_NUMPAGES:
            return {
                ...state,
                content: setPages(state, action.pages),
                pages: action.pages
            };

        case TemplateTypes.SET_MIN_NUMPAGES:
            return {
                ...state,
                minPages: action.minPages
            };

        case TemplateTypes.RESET:
            return {
                tool: null,
                props: {},
                selectedId: null,
                content: [],
                loadedContent: []
            };

        default:
            return state;
    }
};